import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
})

/** Chaves de query centralizadas para invalidação consistente. */
export const qk = {
  session: ['session'] as const,
  profile: (id: string) => ['profile', id] as const,
  workspaces: ['workspaces'] as const,
  members: (ws: string) => ['members', ws] as const,
  tasks: (ws: string) => ['tasks', ws] as const,
  task: (id: string) => ['task', id] as const,
  templates: (ws: string) => ['templates', ws] as const,
  labels: (ws: string) => ['labels', ws] as const,
  campaigns: (ws: string) => ['campaigns', ws] as const,
  events: (ws: string) => ['events', ws] as const,
  calendar: (ws: string) => ['calendar', ws] as const,
  routines: (ws: string) => ['routines', ws] as const,
  approvals: (ws: string) => ['approvals', ws] as const,
  notifications: (ws: string) => ['notifications', ws] as const,
  activity: (entityId: string) => ['activity', entityId] as const,
  dashboard: (ws: string) => ['dashboard', ws] as const,
}
